'use client'

import Image from 'next/image'
import { ButtonHTMLAttributes, forwardRef, useState } from 'react'
import { Button, ButtonProps } from '../atoms/Button'
import { cn } from '../../utils'

type DropdownMenuProps = ButtonHTMLAttributes<HTMLButtonElement> &
	ButtonProps & {
		hideCaret?: boolean
		label?: string
	}

export const DropdownMenu = forwardRef<ButtonProps, DropdownMenuProps>(
	({ children, className, label, hideCaret, ...rest }, ref) => {
		const [isOpen, setOpen] = useState(false)
		return (
			<div className="inline-block">
				{isOpen && (
					<div
						onClick={() => setOpen(!isOpen)}
						className="absolute w-full h-full top-0 left-0"
					/>
				)}
				<Button
					onClick={() => setOpen(!isOpen)}
					className={cn('flex justify-between px-4', className)}
					{...rest}
				>
					{!!label && <span className="mr-1">{label}</span>}
					{!hideCaret &&
						(isOpen ? (
							<Image
								src="/images/top-black-carret.svg"
								width="12"
								height="12"
								alt="top carret"
							/>
						) : (
							<Image
								src="/images/down-black-carret.svg"
								width="12"
								height="12"
								alt="top carret"
							/>
						))}
				</Button>
				<div className="absolute">{isOpen && children}</div>
			</div>
		)
	},
)

DropdownMenu.displayName = 'DropdownMenu'
